export default {"src":"/_next/static/media/chevron-down.3b1101ce.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};